import type { PageConfig } from "../types.ts";

export function getDynamicStyles(pageConfig: PageConfig) {
  return `
    :root {
      --rw-primary-color: ${pageConfig.theme.primaryColor};
      --rw-blue-color: ${pageConfig.theme.blueColor};

      --rw-font-normal-family: ${pageConfig.theme.fontNormal.fontFamily};
      --rw-font-normal-weight: ${pageConfig.theme.fontNormal.fontWeight};
      --rw-font-normal-size-small: ${pageConfig.theme.fontNormal.sizeSmall}px;
      --rw-font-normal-size-medium: ${pageConfig.theme.fontNormal.sizeMedium}px;
      --rw-font-normal-size-large: ${pageConfig.theme.fontNormal.sizeLarge}px;

      --rw-font-large-family: ${pageConfig.theme.fontLarge.fontFamily};
      --rw-font-large-weight: ${pageConfig.theme.fontLarge.fontWeight};
      --rw-font-large-size-small: ${pageConfig.theme.fontLarge.sizeSmall}px;
      --rw-font-large-size-medium: ${pageConfig.theme.fontLarge.sizeMedium}px;
      --rw-font-large-size-large: ${pageConfig.theme.fontLarge.sizeLarge}px;
    }
  `.replace(/\n/g, "");
}